
/** Default ana sayfa seçimleri  */
export enum HomeSelectionEnum {

  /** Ana Panel */
  MainPanel = 0,

  /** Tesis */
  FacilityManager = 1,

  /** Harita */
  Map = 2
}
